<template>
  <div>
    <div class="fullcard yellow-1st padding-1st">
      <div class="center800">
        <Navigation/>
        <div class="internclub-brand">
          Mentorship
        </div>
        <div class="headlines">
          <div class="text-head">
            Support the next generation of builders, doers, and makers.
          </div>
          <div class="text-subhead">
            Support the next generation of students and new grads.
          </div>
        </div>
        <MentorRegistration key="top-reg" />
      </div>
    </div>
    <!-- <div style="display: flex; align-items: center; justify-content: center;">
      <Flipper :photos="photos" />
    </div> -->
    <div class="corporateproof">
      <div class="corporations">
        <div><img src="/logos/mentorship-companies/twitch.png" class="mentorship-brand-logo" alt="Twitch logo" /></div>
        <div><img src="/logos/mentorship-companies/spacex.png" class="mentorship-brand-logo" alt="SpaceX logo" /></div>
        <div><img src="/logos/mentorship-companies/nbc.png" class="mentorship-brand-logo" alt="NBC logo" /></div>
        <div><img src="/logos/mentorship-companies/robinhood.png" class="mentorship-brand-logo" alt="Robinhood logo" /></div>
        <div><img src="/logos/mentorship-companies/microsoft.png" class="mentorship-brand-logo" alt="Microsoft logo" /></div>
      </div>
      <div class="text-subhead">
        Join <b>500+</b> other mentors supporting interns and new grads during their summer online.
      </div>
    </div>
    <div class="fullcard dark-1st padding-1st">
      <div class="text-large-body center800" style="color: white;">
        <p>
          Share your skills with the future workforce.
        </p>
        <p>
          Without leaving your office, connect with learners to provide insight into your career to transform their learning.
        </p>
        <p>
          Through our skills-based volunteering program, you can browse and accept relevant virtual volunteer opportunites or offer a virtual chat on a topic of your choice to reach more learners.
        </p>
        <p>
          Build your professional profile through volunteering.
        </p>
      </div>
    </div>
    <div style="display: flex; align-items: center; justify-content: center;">
      <Flipper :photos="photos" />
    </div>
    <div class="fullcard padding-2nd footer">
      <div class="center800">
        <div class="text-subhead">
          Join <b>500+</b> other mentors supporting interns and new grads during their summer online.
        </div>
        <MentorRegistration key="bot-reg" />
        <div class="text-subhead" style="margin-top: 80px;">
          <p>
            From the folks who brought you intern.community
          </p>
          <p>
            Contact us at
            <a
              href="mailto:aanant@umich.edu"
              style="text-decoration: none;color:#59A5F8"
              >aanant@umich.edu</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Flipper from './Flipper.vue';
import MentorRegistration from './MentorRegistration.vue';
import Navigation from './Navigation.vue';

export default {
  name: 'MentorPage',
  components: { Flipper, MentorRegistration, Navigation },
  data() {
    return {
      photos: [
        {
          imageUrl: 'intern-photos/bonfire.png',
          alt: 'Five interns posing next to each other at a bonfire event.',
          caption: 'Real interns. Real connections.',
        },
        {
          imageUrl: 'intern-photos/bonfire-2.png',
          alt: 'Interns on the beach shaking hands.',
          caption: 'Real interns. Not stock photos.',
        },
        {
          imageUrl: 'intern-photos/pool.png',
          alt: 'Lots of people around a pool at a pool party.',
          caption: 'Real interns. Real connections.',
        },
        {
          imageUrl: 'intern-photos/hanging-out.png',
          alt:
            'Interns chatting in front of a grafitti wall, with one man pointing at the camera.',
          caption: 'Real interns. Not stock photos.',
        },
        {
          imageUrl: 'intern-photos/andyblueyo.png',
          alt: 'A woman with an intern community sticker on her forehead.',
          caption: 'Join our intern community!',
        },
        {
          imageUrl: 'intern-photos/some-pals.png',
          alt: 'Seven interns posing next to each other.',
          caption: 'Interns from Howard University.',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
/* CSS files add styling rules to your content */

.fullcard {
  margin: 12px;
  margin-left: 4px;
  margin-right: 4px;
  margin-bottom: 0px;
  display: flex;
  flex-grow: 1;
  border-radius: 12px;
}

.padding-1st {
  padding: 100px;
  padding-left: 40px;
  padding-right: 40px;
}

.padding-2nd {
  padding: 80px;
  padding-left: 40px;
  padding-right: 40px;
}

.yellow-1st {
  background-color: #fbe869;
}

.dark-1st {
  background-color: #232323;
}

.white-1st {
  background-color: #ffffff;
  border: 8px solid #f1f1f1;
}

.blue-1st {
  background-color: #59a5f8;
}

.center800 {
  max-width: 800px;
  margin: auto;
}

.center1200 {
  max-width: 1200px;
  margin: auto;
}

.internclub-brand {
  font-family: 'Avenir', sans-serif;
  font-style: normal;
  font-weight: 800;
  font-size: 48px;
  text-align: center;
  color: #000000;
}

.text-head {
  font-family: 'Cabin', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: var(--xl-text);
  text-align: center;
  color: #000000;
}

.text-subhead {
  font-family: 'Cabin', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: var(--med-text);
  text-align: center;
  color: rgba(0, 0, 0, 0.5);
}

.headlines {
  display: flex;
  flex-direction: column;
}

.headlines > div {
  margin-bottom: 20px;
  margin-top: 20px;
}

.email-form {
  margin: auto;
  margin-top: 20px;
  margin-bottom: 40px;
  max-width: max-content;
}

.email-input {
  background: #fef9d9;
  border-radius: 9999px;
  box-shadow: 0px 4px 60px rgba(70, 70, 70, 0.2);
  min-width: var(--email-width);
  height: 53px;
  border: none;
  font-size: var(--med-text);
  font-weight: 600;
  padding-left: 20px;
  font-family: 'Avenir', sans-serif;
}

.email-submit {
  background: #ec6569;
  border-radius: 9999px;
  height: 53px;
  border: none;
  font-size: var(--med-text);
  margin: 12px;
  padding-left: 20px;
  padding-right: 20px;
  font-weight: 600;
  font-family: 'Avenir', sans-serif;
  color: white;
}

.corporations {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  margin-top: 40px;

  & > div {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 calc(max(20%, 200px));
  }
}

img.mentorship-brand-logo {
  max-height: 40px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.text-large-body {
  font-size: var(--big-text);
  font-family: 'Avenir', sans-serif;
  display: inline;
}

.tm-text {
  font-size: var(--big-text);
  color: #59a5f8;
  font-family: 'Avenir', sans-serif;
  font-weight: 600;
}

.profile-img {
  border-radius: 9999px;
  height: 100px;
  float: left;
  margin-right: 40px;
}

.tm-source {
  font-family: 'Cabin', sans-serif;
  color: #232323;
  font-size: var(--med-text);
  display: flex;
  margin-top: 40px;
  align-items: center;
}

.corporateproof {
  margin-top: 6em;
  margin-bottom: 6em;

  .text-subhead {
    margin-top: 3em;
  }
}
</style>
